import styled from 'styled-components';
import CenterInfoFightComponentRender from './GenericComponentMatchCard';
import { BoxThreeWrestlersContainer } from './GenericComponentCssMatchCard';
import { BoxWinnerGeneric, DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard'

const BoxWrestler = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    width: calc(100% - 30px);

    & .name-wrestler {
        font-size: 12px;
        font-weight: 500;
        margin: 0;
        text-transform: uppercase;
        width: 100%;
        padding: 0 30px;
        // spazio caratteri
        letter-spacing: 5px;
        // se supera il width va a capo
        white-space: normal;
        overflow-wrap: break-word;
    }

    &.box-wrestler.right .name-wrestler {
        text-align: right;
        justify-content: flex-end;
    }
`

const AvatarWrestler = styled.div`
    position: relative;
    width: 75px;
    height: 75px;
    border: 2px solid rgba(163, 27, 27, 0.45);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba(163, 27, 27, 0.85);
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`

function SixMatchCard(props) {
    const matchInfo = props.matchInfo;
    const keyMatchInfo = props.keyMatchInfo;
    const navigateToWrestler = props.navigateToWrestler;

    // prendo props.match.wrestlers e lo divido in due array uguale.. se dispari, il primo array avra' un elemento in più
    const wrestlers = matchInfo.wrestlers;
    const wrestlers1 = wrestlers.slice(0, Math.ceil(wrestlers.length / 2));
    const wrestlers2 = wrestlers.slice(Math.ceil(wrestlers.length / 2));

    // renderizza un singolo wrestler
    function renderSingleWrestler(wrestler, key, side) {
        if (side === 'left') {
            return (
                <BoxWrestler className={`box-wrestler ${side}`}>
                    <AvatarWrestler className="avatar-wrestler"
                        onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                    
                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-w-100">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ? 
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarWrestler>
                    <h6 className="name-wrestler">{wrestler.name}</h6>
                </BoxWrestler>
            )
        } else {
            return (
                <BoxWrestler className={`box-wrestler ${side}`}>
                    <h6 className="name-wrestler">{wrestler.name}</h6>
                    <AvatarWrestler className="avatar-wrestler"
                        onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-w-100">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ? 
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarWrestler>
                </BoxWrestler>
            )
        }
    }

    // JSX
    return (
        <DefaultContainerCard 
         key={keyMatchInfo}
         style={{paddingLeft: '80px', paddingRight: '80px'}}
         className="six-match-card">
            <TopDecorColor />

            <BoxThreeWrestlersContainer className="box-three-wrestlers-container-left">

                {wrestlers1.map((wrestler, key) => (
                    renderSingleWrestler(wrestler, key, 'left')
                ))}

            </BoxThreeWrestlersContainer>

            <CenterInfoFightComponentRender
                className="center-info-fight-component-render-six" 
                nameMatch={matchInfo.type_match.type}
                matchInfo={matchInfo}
            />

            <BoxThreeWrestlersContainer className="box-three-wrestlers-container-right">

                {wrestlers2.map((wrestler, key) => (
                    renderSingleWrestler(wrestler, key, 'right')
                ))}

            </BoxThreeWrestlersContainer>

        </DefaultContainerCard>
    )
}

export default SixMatchCard;